(() => {
  const upsellNodes = document.querySelectorAll('[data-upsell-product]');

  upsellNodes.forEach((node) => {
    const button = node.querySelector('[data-upsell-add-to-cart]');
    const label = button.querySelector('[data-upsell-cta-label]');
    const variantId = node.dataset.upsellVariantId;
    const defaultLabel = label.textContent;

    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;

      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: [{ id: variantId, quantity: 1 }] };

      if (cartDrawer) {
        body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Add to cart failed');

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        }

        label.textContent = 'Tilføjet!';
        setTimeout(() => {
          label.textContent = defaultLabel;
          button.disabled = false;
        }, 1500);
      } catch (error) {
        console.error('Upsell add to cart error:', error);
        button.disabled = false;
      }
    });
  });
})();